import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate("/select-role");
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="brand-row">
          <div className="brand-logo">
            <img
              src={`${process.env.PUBLIC_URL}/buildking-logo.png`}
              alt="HSP logo"
            />
          </div>
          <div>
            <div className="brand-name">HSP Monitoring</div>
          </div>
        </div>

        <h1>Sign in</h1>
        <p className="sub">Enter your credentials to continue</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="field-group">
            <label htmlFor="userId">User ID</label>
            <input
              id="userId"
              type="text"
              placeholder="Enter your user ID"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              autoComplete="username"
            />
          </div>

          <div className="field-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="login-btn">
            Sign in
          </button>
        </form>
      </div>

      <style>{`
        .login-page {
          min-height: 100vh;
          background: url('${process.env.PUBLIC_URL}/landing-439416.jpg') center center / cover no-repeat;
          display: grid;
          place-items: center;
          padding: 24px;
        }
        .login-page::before {
          content: '';
          position: fixed;
          inset: 0;
          background: rgba(10, 20, 50, 0.55);
          z-index: 0;
        }
        .login-card {
          position: relative;
          z-index: 1;
        }
        .login-card {
          background: #fff;
          border-radius: 16px;
          width: 100%;
          max-width: 420px;
          padding: 48px;
          box-shadow: 0 30px 80px rgba(0,0,0,0.3);
        }
        .login-card h1 {
          margin: 0 0 6px;
          font-size: 26px;
          font-weight: 700;
        }
        .login-card p.sub {
          color: var(--c-muted);
          margin: 0 0 32px;
          font-size: 14px;
        }
        .brand-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 36px;
        }
        .brand-logo {
          width: 40px;
          height: 40px;
          background: var(--c-surface);
          border: 1px solid var(--c-border);
          border-radius: 8px;
          display: grid;
          place-items: center;
          overflow: hidden;
        }
        .brand-logo img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }
        .brand-name {
          font-weight: 700;
          font-size: 18px;
        }
        .login-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .field-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .field-group label {
          font-size: 13px;
          font-weight: 600;
          color: #374151;
        }
        .field-group input {
          border: 1px solid var(--c-border, #e5e7eb);
          border-radius: 8px;
          padding: 10px 14px;
          font-size: 14px;
          outline: none;
          transition: border-color 0.15s, box-shadow 0.15s;
          width: 100%;
          box-sizing: border-box;
        }
        .field-group input:focus {
          border-color: var(--c-primary, #2563eb);
          box-shadow: 0 0 0 3px rgba(37,99,235,0.15);
        }
        .login-btn {
          margin-top: 8px;
          padding: 11px;
          background: var(--c-primary, #2563eb);
          color: #fff;
          border: none;
          border-radius: 8px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.15s;
          width: 100%;
        }
        .login-btn:hover {
          background: #1d4ed8;
        }
      `}</style>
    </div>
  );
};

export default Login;
